export default "__VITE_PUBLIC_ASSET__c17aca3d__"